<!--
 * @Author: Merlin
 * @Date: 2025-01-23 15:49:35
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-08 14:06:53
 * @Description: 大表格入口文件 
-->
<template>
    <ClientOnly>
        <div class="mt-5 mb-10 w-full history-table">
            <CasinoHistoryTabs
                class="mb-4"
                v-model="sNowTab"
                :isMobileMode="isMobileMode"
                :items="['history', 'myBets', 'highRollers', 'rareWins']"
                v-model:sSizePicker="sSizePicker"
            />
            <!-- ↑ 上方的页签组件（选项卡） -->
            <!-- ↓ 表格内容 -->
            <div
                v-if="lists[sNowTab]?.list?.length === 0"
                class="m-auto flex justify-center flex-col items-center select-none pointer-events-none"
            >
                <img
                    class="w-[165px] h-[165px] select-none pointer-events-none"
                    src="~/assets/imgs/casino/no-data-image.webp"
                />
                <div class="text-[#55657e] font-medium">{{ t.Noinformation }}</div>
            </div>
            <!-- ↑ 没有数据时的提示（狗头Logo）-->
            <!-- ↓ 有数据时显示的表格 -->
            <div v-else class="table-wrap flex relative flex-col gap-2 w-full">
                <!-- 列表头，伪 theader -->
                <div
                    class="w-full flex px-2 py-2 text-[11px] font-bold text-[#55657E] justify-around"
                >
                    <component
                        :is="lists[sNowTab].headerComponent"
                        :isMobileMode="isMobileMode"
                    ></component>
                </div>
                <!-- 列表，伪 tbody -->
                <div
                    class="gap-2 flex w-full"
                    :class="{
                        [animateClass]: !!animateClass,
                        'animation--shadow': lists[sNowTab].key !== 'betsOnline' && reduceHistoryList.length > 2,
                    }"
                >
                    <!-- ↓ 表格行组件外套 -->
                    <div
                        class="w-full flex-nowrap font-semibold flex rounded-md min-h-[50px] items-center bg-[rgba(22,31,44,.8)] px-2 py-2 text-[#93ACD3] justify-around"
                        v-for="(history, idx) in reduceHistoryList"
                        :key="history?._id || idx"
                        :test-mark="history?._id || 'no id'"
                    >
                        <!-- ↓ 表格的小单元格 -->
                        <component
                            v-if="lists[sNowTab]?.bodyComponent"
                            :is="lists[sNowTab].bodyComponent"
                            :isMobileMode="isMobileMode"
                            :key="history?._id || idx"
                            v-bind:history="history"
                            :userModalControl="userModalControl"
                            :seeRoundDetail="() => seeRoundDetail(history)"
                        ></component>
                    </div>
                </div>
            </div>
        </div>
        <!--
            ↑ 表格内容结束 
            ↓ 以下弹出窗口 
            ↓ 重要说明 💥💥💥💥💥
            ↓ 子组件（表格行）内部不要包含窗口组件并自行弹出窗口，应在父组件弹出窗口， 
            ↓ 否则在数据更新时子组件（表格行）会被删除，这时弹出的窗口将卡死失效
        -->
        <!-- ↓ 游戏记录的详情 -->
        <CasinoHistoryModalGameDetali
            @handlePrinciple="handlePrinciple"
        />
        <!-- ↓ 同上，是 crash, circle 游戏专用的游戏详情 -->
        <CasinoHistoryModalRoundDetails
            v-model="roundModal"
            :roundNum="roundData.num"
            :gameName="roundData.gameName"
            @handleOpenModel="(oData) => userModalControl(oData.user._id)"
        />
        <!-- ↓ 公平性说明 -->
        <ModalMobilePrinciple
            :model-value="principleVisible"
            @update:model-value="handlePrinciple"
        />
        <!-- ↓ 用户信息窗口 -->
        <CasinoHistoryModalUserProfile
            v-model="userModal"
            :user-id="String(userID4Modal)"
        />
    </ClientOnly>
</template>

<script lang="ts" >
export default defineComponent({ name: 'HistoryBigTable' });
</script>

<script setup lang="ts">
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import CasinoHistoryHeadersMyBets from '~/components/Casino/History/Headers/MyBets.vue';
import CasinoHistoryBodysMyBets from '~/components/Casino/History/Bodys/MyBets.vue';
import CasinoHistoryHeadersAllBets from '~/components/Casino/History/Headers/AllBets.vue';
import CasinoHistoryBodysAllBets from '~/components/Casino/History/Bodys/AllBets.vue';
import CasinoHistoryHeadersBetsOnline from '@/components/Casino/History/Headers/BetsOnline.vue';
import CasinoHistoryBodysBetsOnline from './Bodys/BetsOnline.vue';
import CasinoHistoryHeadersHistory from './Headers/History.vue';
import CasinoHistoryBodysHistory from './Bodys/History.vue';
// ↑ Vue 组件
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import useGlobalStore from '@/stores/global';
// ↑ stores
import useTranslation from '~/i18n/useTransLation';
import { useHome } from '@/socket/home';
import { useGameSocket } from '@/socket/game';
import { getGameApi } from '@/common/js/gameAbout';
import {iPaginationMax} from '@/components/Casino/History/Tabs/ts/Tabs';

const globalStore = useGlobalStore();
const route = useRoute();
const { EMIT_SUBSCRIBE_ALL, EMIT_UNSUBSCRIBE_ALL } = useGameSocket(); // 订阅或取消订阅游戏大表格 All 的动态数据
const joinStateStore = useJoinStateStore();
const userStore = useUserStore();
const sSizePicker = ref('10');
const t = useTranslation();
const gameHistoryStore = useGameHistoryStore();
const animateClass = ref('');
const userModal = ref(false);
const userID4Modal = ref('');
const roundModal = ref(false); // crash + circle 专用
const roundData = ref({
    // crash + circle 专用
    num: 0,
    gameName: '',
});
const emit = defineEmits([
    'update:sSizePicker',
]);
const { hasLogged } = await getUserInfo();

const sNowTab = ref(hasLogged ? HistoryTabsEnum.MyBets : HistoryTabsEnum.All);

const principleVisible = ref(false);
const { theme } = useRuntimeConfig().public.tailwind;
const { max } = theme.extend.screensInt.sm;
// ↓进入小屏模式 ◆
const isMobileMode = computed(() => {
    return globalStore.innerWidth <= max;
});

// 表單數據，
const lists = reactive({
    betsOnline: {
        key: HistoryTabsEnum.BetsOnline, // 页签名称
        list: computed(() => joinStateStore.betsOnlineData as any), // 数据
        headerComponent: markRaw(CasinoHistoryHeadersBetsOnline), // 表头组件，类似 thead
        bodyComponent: markRaw(CasinoHistoryBodysBetsOnline), // 表体组件，类似 tbody
    },
    all: {
        key: HistoryTabsEnum.All,
        list: computed(() => Object.freeze(joinStateStore.historyDelay.all as any)),
        headerComponent: markRaw(CasinoHistoryHeadersAllBets),
        bodyComponent: markRaw(CasinoHistoryBodysAllBets),
    },
    history: {
        key: HistoryTabsEnum.History,
        list: computed(() => Object.freeze(joinStateStore.historyDelay.all as any)),
        headerComponent: markRaw(CasinoHistoryHeadersHistory),
        bodyComponent: markRaw(CasinoHistoryBodysHistory),
    },
    high: {
        key: HistoryTabsEnum.High,
        list: computed(() => joinStateStore.historyDelay.high as any),
        headerComponent: markRaw(CasinoHistoryHeadersAllBets),
        bodyComponent: markRaw(CasinoHistoryBodysAllBets),
    },
    rare: {
        key: HistoryTabsEnum.Rare,
        list: computed(() => joinStateStore.historyDelay.rare as any),
        headerComponent: markRaw(CasinoHistoryHeadersAllBets),
        bodyComponent: markRaw(CasinoHistoryBodysAllBets),
    },
    myBets: {
        key: HistoryTabsEnum.MyBets,
        list: computed(() => Object.freeze(gameHistoryStore.gameHistoryDelay.response)),
        headerComponent: markRaw(CasinoHistoryHeadersMyBets),
        bodyComponent: markRaw(CasinoHistoryBodysMyBets),
    },
});

// 记录最新收到的数据的时间信息 
// 示例：timestamp: "2025-04-08T06:01:42.000Z"
const aLengthRecord = ['', '']; 
watch(
    [
        () => lists.all.list,
        () => lists.myBets.list,
    ],
    (aNewList) => {
        // console.log(`游戏下方大表格数据变化\n${aLengthRecord[0]} -> ${aNewList[0].length}\n${aLengthRecord[1]} -> ${aNewList[1].length}`);
        const timestamp0 = (aNewList[0] || [])[0]?.timestamp || '';
        const timestamp1 = (aNewList[1] || [])[0]?.timestamp || '';
        // ↓ 结果为 true 则播放动画
        let showAnimation = [
            sNowTab.value === HistoryTabsEnum.All, // 要在特定页
            timestamp0 > aLengthRecord[0], // 对比字符串时间，true 表示来了“新” 数据 
            aLengthRecord[0], // 如果为空字符，表示是首次加载整个数据，不播放动画
        ].every(Boolean);
        showAnimation ||= [
            sNowTab.value === HistoryTabsEnum.MyBets,
            timestamp1 > aLengthRecord[1],
            aLengthRecord[1],
        ].every(Boolean);
        // ↓ 记录起来，用于下次判断
        aLengthRecord[0] = timestamp0;
        aLengthRecord[1] = timestamp1;
        // ↓ 最后按情况添加动画类名
        if (showAnimation) {
            animateClass.value = 'animation--start';
            setTimeout(() => {
                animateClass.value = '';
            }, 500);
        }
    },
    { deep: true, immediate: true },
);

// ↓ 这是最终显示在表格中的数据，
// ↓ 此数组长度按用户设定的 "Size" 呈现
const reduceHistoryList = computed(() => {
    const iEndAt = Number(sSizePicker.value);
    const list = lists[sNowTab.value]?.list.slice(0, iEndAt);
    return list;
});

/**
 * 公平性原理弹框
 */
const handlePrinciple = () => {
    principleVisible.value = !principleVisible.value;
};

// ↓ 下发给子组件用于显示用户信息
function userModalControl(sUserID) {
    console.log('打开窗口, user id =', sUserID);
    userModal.value = sUserID > 0;
    userID4Modal.value = String(sUserID);
}

// ↓ 查看某局游戏结果 （circle + crash)
function seeRoundDetail(oHistory) {
    console.log('查看某局游戏结果', deepCopy(oHistory));
    roundModal.value = true;
    roundData.value = {
        num: oHistory.num,
        gameName: oHistory.gameName,
    };
}
/**
 * 监听页面滚动
 */
function handleScroll(){
    // 页面滚动距离
    const scrollTop = window.scrollY || window.pageYOffset;
    // 获取视口的高度
    const viewportHeight = window.innerHeight;
    // 页面最大滚动高度
    const documentHeight = document.documentElement.scrollHeight;
    // 当前limit应小于当前tab返回的数据条数
    const iSize = Number(sSizePicker.value);
    if (
        iSize < iPaginationMax
        && iSize < lists[sNowTab.value]?.list.length 
        && (scrollTop + viewportHeight >= documentHeight)
    ){
        const iNewSize = Math.min(iPaginationMax, iSize + 10);
        const limit = (iNewSize).toString();
        console.log('到底了', limit);
        nextTick(() => {
            sSizePicker.value = limit;
        });
    }
}

// 监听tab切换，切到 all 页签时开启实时推送，并监听获取推送数据，否则关闭实时推送
watch(
    () => sNowTab.value,
    (newVal, oldVal) => {
        if (newVal === oldVal) return;
        console.log('已经切换到：', newVal);
        const atAllTab = newVal === HistoryTabsEnum.All;
        subscribeOrCandelDataForTabAll(atAllTab);
        
    },
);

// ↓ 订阅或取消订阅 all 页签下的数据（位于游戏页时）
function subscribeOrCandelDataForTabAll(atAllTab) {
    const sApi = getGameApi();
    console.log('Current Game: ', sApi);
    if (atAllTab) {
        EMIT_SUBSCRIBE_ALL(sApi);
    } else {
        EMIT_UNSUBSCRIBE_ALL(sApi);
    }
}

// ======= ↓ 最后是生命周期 =====================================================

// ↓ 离开时要取消订阅
onBeforeUnmount(() => {
    subscribeOrCandelDataForTabAll(false);
    window.removeEventListener('scroll', handleScroll)
});

onMounted(() => {
    // 未登录而默认位置是 All 页签
    if (sNowTab.value === HistoryTabsEnum.All) {
        subscribeOrCandelDataForTabAll(true);
    }
    nextTick(() => {
        window.addEventListener('scroll', handleScroll)
    })
    
});
</script>


<style scoped lang="scss">
.historyContainer::after {
    background: linear-gradient(181deg, rgba(13, 19, 28, 0) 21.34%, #0d131c 99.18%);
    bottom: 0;
    content: '';
    height: 254px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
}

.animation--start {
    animation: shuffle 0.5s ease-out;
    will-change: transform;
    & > :first-child {
        animation: fadeInOpacity 0.5s ease-out;
        will-change: opacity;
    }
}

.animation--shadow {
    position: relative;
    &::after {
        background: linear-gradient(181deg, rgba(13, 19, 28, 0) 21.34%, #0d131c 99.18%);
        bottom: 0;
        content: '';
        height: 254px;
        left: 0;
        pointer-events: none;
        position: absolute;
        width: 100%;
        will-change: top, bottom, scroll-position;
    }
}

@keyframes shuffle {
    0% {
        transform: translateY(-50px);
    }
    to {
        transform: translateY(0px);
    }
}

@keyframes fadeInOpacity {
    0% {
        opacity: 0;
    }
    to {
        opacity: 0.75;
    }
}
</style>
